import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';
import s from '../styles/DetailContent.module.css';

const Knowledge39 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='小田急グループのゴルフ会員権とは？' fontWeight={700} />
                <p>
                    小田急グループのゴルフ場は、小田急電鉄の子会社である株式会社小田急スポーツサービスが運営しています。
                    <br />
                    運営コースは以下の2コースで、他のグループと比べるとコース数は多くありません。
                </p>
                <div className={s.h4_link}>・小田急藤沢ゴルフクラブ（神奈川県、パブリックコース）</div>
                <div className={s.h4_link}>
                    ・<a href='https://juchi.jp/courses/336'>富士小山ゴルフクラブ</a>（静岡県、会員制コース）
                </div>
                <p>
                    小田急藤沢ゴルフクラブはビジター中心のパブリックコースのため、会員権が取引されるのは主に富士小山ゴルフクラブです。
                    <br />
                    なお、富士小山ゴルフクラブは2023年4月1日に小田急スポーツサービスへ吸収合併されており、それ以前とは運営体制が変わっている点にご留意ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='富士小山ゴルフクラブの特徴' fontWeight={700} />
                <p>
                    富士小山ゴルフクラブは静岡県小山町、標高約600mに位置し、東名高速道路
                    御殿場ICから約20分でアクセスできます。
                    <br />
                    280ヤードの練習場を併設しており、練習環境の充実度も特徴の一つです。
                </p>
                <Heading3 title='会員権の形態' />
                <p>
                    富士小山ゴルフクラブは2022年10月1日付で株式併合（10株→1株）を実施し、小田急スポーツサービスの完全子会社となりました。
                    <br />
                    併合後は「会員預り保証金」（額面10万円）という形態で会員権が取引されています。2023年1月時点の会員数は1,475名です。
                    <br />
                    ※系列間での優待制度や相互利用プログラムについては、確認できる公式情報がありませんでした。特典を検討される際は、購入前に必ずクラブへ直接ご確認ください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    小田急グループはコース数こそ多くありませんが、都心からアクセスしやすい富士小山ゴルフクラブは根強い人気があります。
                    <br />
                    <br />
                    会員権の形態や名義書換の可否など、購入前に確認しておきたいポイントは弊社にお気軽にお問合せください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge39;
